import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getFileLiveUrl } from "../../utils";

const NextPage = (props) => {
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    if (props.dataSource) setDataList(props.dataSource);
  });
  return (
    <div>
      <Row>
        {dataList.map((item, i) => {
          return (
            <Col md={4} className="mb-3">
              <Link to={`/gallery/${item.category}`}>
                <Card className="card-hover">
                  <Card.Img
                    src={getFileLiveUrl(item.feature_image)}
                    style={{ height: "200px" }}
                  />
                  <Card.Body
                    className="text-center fw-bold"
                    style={{ overflow: "auto", color: "black" }}
                  >
                    {item.title}
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default NextPage;
